import React, { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import Logo from 'svg/logo';

/**
 * The Age Gate
 *
 * This is where users under 13 are sent
 */
const AgeJail = (props) => {
  // eslint-disable-next-line
  const [cookie, setCookie] = useCookies(['tooYoung']);
  useEffect(() => {
    setCookie('tooYoung', true, { path: '/' });
    // eslint-disable-next-line
  }, []);
  return (
    <article className='AgeJail'>
      <div className='GenericAlert'>
        <Logo className='Intro__logo' />
        <h1 className='GenericAlert__title'>Sorry</h1>
        <section className='GenericAlert__description'>
          <p>You are not eligible to participate at this time.</p>
        </section>
      </div>
    </article>
  )
};

export default AgeJail;
